<template>
  <item-list
      v-if="dancersCopy"
      :items="dancersCopy"
      :data-table-config="dataTableConfig"
      :actions="dataTableConfig.actions"
      :tooltips="dataTableConfig.tooltips"
      :lockActions="lockActions"
      :show-actions="actions"
      :selectable="selectable"
      :selected.sync="selectedItems"
      :loading="loading"
      header="Tänzer/innen"
  ></item-list>
</template>

<script>
import {mapState} from 'vuex';
import ItemList from '../common/ItemList';

export default {
  components: {
    'item-list': ItemList
  },
  props: {
    selected: {
      type: Array,
      default: null
    },
    selectable: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: null
    },
    showBroken: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedItems: {
      deep: true,
      handler() {
        this.$emit('update:selected', this.selectedItems);
      }
    },
    selected() {
      this.$set(this, 'selectedItems', this.selected);
    },
    dancers: {
      deep: true,
      handler() {
        this.copyDancers();
      }
    }
  },
  data() {
    return {
      dancersCopy: null,
      selectedItems: [],
      dataTableConfig: {
        loadingDataText: 'Lade Tänzer/innen',
        noDataText: 'Keine Tänzer/innen vorhanden',
        rowsPerPageText: 'Zeilen pro Seite',
        headers: [
          {text: this.$t('first_name'), value: 'first_name', align: 'left'},
          {text: this.$t('last_name'), value: 'last_name', align: 'left'},
          {text: this.$t('birth_date'), value: 'birth_date', align: 'left'},
          {text: this.$t('age'), value: 'age', align: 'left'},
          {text: this.$t('age_group'), value: 'age_group', align: 'left'}
        ],
        items: {
          large: [
            {value: 'first_name'},
            {value: 'last_name'},
            {value: 'birth_date', formatFunction: '$formatDate'},
            {value: 'age'},
            {value: 'age_group'}
          ],
          small: [
            {value: 'first_name'},
            {value: 'last_name'},
          ]
        },
        tooltips: [
          {
            label: 'Geburtsdatum muss korrigiert werden',
            icon: 'warning',
            color: 'yellow',
            visible: dancer => dancer.needs_birthday
          }
        ],
        actions: [
          {
            label: this.$t('edit'),
            icon: 'edit',
            click: dancer => {
              this.$router.push(`/user/dancer/edit/${dancer.id}`);
            }
          },
          {
            label: this.$t('delete'),
            icon: 'delete',
            click: dancer => {
              this.$store.commit('confirm', {
                headline: 'Tänzer/in löschen',
                text: this.$t('questions.remove', [dancer.full_name]),
                callback: () => {
                  this.lockActions = true;

                  axios.delete(`/api/v1/dancers/${dancer.id}`).then(response => {

                    if (!response.data.success) {
                      this.$store.commit('snackBar', {
                        color: 'error',
                        text: this.$t(response.data.message)
                      });
                      this.lockActions = false;
                      return;
                    }

                    this.$store.dispatch('loadStarterTemplates');

                    this.$store.commit('removeDancer', dancer.id);

                    this.$store.commit('snackBar', {
                      color: 'success',
                      text: this.$t('was_deleted', [dancer.full_name])
                    });

                    this.lockActions = false;
                  }, errorResponse => {
                    console.log(errorResponse);
                    this.lockActions = false;
                  });
                }
              });
            }
          }
        ],
      },
      lockActions: false
    }
  },
  computed: mapState(['dancers']),
  mounted() {
    this.copyDancers();
  },
  methods: {
    copyDancers() {
      if (this.items !== null) {
        this.dancersCopy = _.cloneDeep(this.items);
      } else {
        this.dancersCopy = _.cloneDeep(this.dancers);
      }

      this.dancersCopy.items = [];
      _.each(this.dancers.items, dancer => {
        if (!dancer.needs_birthday || (dancer.needs_birthday && this.showBroken)) {
          this.dancersCopy.items.push(_.cloneDeep(dancer));
        }
      });
    }
  }
}
</script>
